import { render, staticRenderFns } from "./UChat.vue?vue&type=template&id=c90a8284&"
import script from "./UChat.vue?vue&type=script&lang=ts&"
export * from "./UChat.vue?vue&type=script&lang=ts&"
import style0 from "./UChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports